<template>
  <div ref="target">
    <count-up
      v-if="isVisible"
      :key="animationKey"
      :end-val="endVal"
      :options="options"
      :decimalPlaces="decimalPlaces"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'
import CountUp from 'vue-countup-v3'

const endVal = defineModel('endVal', {
  required: true,
  type: Number,
})

const prefix = defineModel('prefix', {
  required: true,
  type: String,
})

const suffix = defineModel('suffix', {
  required: true,
  type: String,
})

const decimalPlaces = defineModel('decimalPlaces', {
  required: true,
  type: Number,
})

const target = ref<HTMLElement | null>(null)
const isVisible = ref(false)
const animationKey = ref(0)

// Use Intersection Observer to detect when element comes into view
useIntersectionObserver(
  target,
  ([{ isIntersecting }]) => {
    if (isIntersecting && !isVisible.value) {
      isVisible.value = true
      // Reset animation by changing key
      animationKey.value++
    }
    else if (!isIntersecting) {
      // Reset when out of view so it can animate again when scrolled back
      isVisible.value = false
    }
  },
  {
    threshold: 0.1,
  },
)

const duration = computed(() => {
  const length = endVal.value.toString().length
  if (length < 4) {
    return 1
  }
  else if (length < 7) {
    return 2
  }
  return 5
})

const options = computed(() => {
  return {
    duration: duration.value,
    prefix: prefix.value,
    suffix: suffix.value,
    separator: ',',
    decimal: '.',
  }
})
</script>
